import { render, staticRenderFns } from "./EditTaskActivityShopDialog.vue?vue&type=template&id=d28e0f4c&scoped=true"
import script from "./EditTaskActivityShopDialog.vue?vue&type=script&lang=js"
export * from "./EditTaskActivityShopDialog.vue?vue&type=script&lang=js"
import style0 from "./EditTaskActivityShopDialog.vue?vue&type=style&index=0&id=d28e0f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28e0f4c",
  null
  
)

export default component.exports